/* eslint indent: ["error", 2, { "SwitchCase": 1 }] */
/* eslint no-param-reassign: ["error",
{ "props": true, "ignorePropertyModificationsFor": ["container"] }] */
import { GoldenLayout } from "golden-layout";
import { buildModernLayout } from "./webcoa/modernLayout";

window.config = {
  settings: {
    showPopoutIcon: false,
    showCloseIcon: false,
  },
  dimensions: {
    minItemHeight: 40,
  },
  content: [
    {
      type: "row",
      content: [
        {
          type: "column",
          width: 40,
          content: [
            {
              type: "component",
              height: 80,
              isClosable: false,
              componentName: "template",
              title: "IC",
              componentState: { id: "client_wrapper" },
            },
            {
              type: "component",
              height: 20,
              isClosable: false,
              title: "IC Options",
              componentName: "template",
              componentState: { id: "icoptions" },
            },
          ],
        },
        {
          type: "column",
          content: [
            {
              type: "row",
              height: 65,
              content: [
                {
                  type: "stack",
                  content: [
                    {
                      type: "component",
                      isClosable: false,
                      title: "Main",
                      componentName: "template",
                      componentState: { id: "mainmenu" },
                    },
                    {
                      type: "component",
                      isClosable: false,
                      title: "Log",
                      componentName: "template",
                      componentState: { id: "log" },
                    },
                  ],
                },
                {
                  type: "stack",
                  width: 30,
                  content: [
                    {
                      type: "component",
                      isClosable: false,
                      title: "Music",
                      componentName: "template",
                      componentState: { id: "music" },
                    },
                    {
                      type: "component",
                      isClosable: false,
                      title: "Players",
                      componentName: "template",
                      componentState: { id: "players" },
                    },
                  ],
                },
              ],
            },
            {
              type: "row",
              content: [
                {
                  type: "component",
                  title: "OOC",
                  componentName: "template",
                  componentState: { id: "ooc" },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

const configMobile = {
  settings: {
    showPopoutIcon: false,
    showCloseIcon: false,
  },
  dimensions: {
    minItemHeight: 40,
  },
  content: [
    {
      type: "row",
      content: [
        {
          type: "column",
          content: [
            {
              type: "component",
              isClosable: false,
              reorderEnabled: false,
              componentName: "template",
              title: "IC",
              componentState: { id: "client_wrapper" },
              height: 56, // Adjust the height proportion as needed
            },
            {
              type: "stack",
              height: 44,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  reorderEnabled: false,
                  title: "IC Options",
                  componentName: "template",
                  componentState: { id: "icoptions" },
                },
                {
                  type: "component",
                  isClosable: false,
                  reorderEnabled: false,
                  title: "Main",
                  componentName: "template",
                  componentState: { id: "mainmenu" },
                },
                {
                  type: "component",
                  isClosable: false,
                  reorderEnabled: false,
                  title: "Log",
                  componentName: "template",
                  componentState: { id: "log" },
                },
                {
                  type: "component",
                  isClosable: false,
                  reorderEnabled: false,
                  title: "Music",
                  componentName: "template",
                  componentState: { id: "music" },
                },
                {
                  type: "component",
                  isClosable: true,
                  title: "Players",
                  componentName: "template",
                  componentState: { id: "players" },
                },
                {
                  type: "component",
                  isClosable: false,
                  reorderEnabled: false,
                  title: "OOC",
                  componentName: "template",
                  componentState: { id: "ooc" },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

// webCOA: an opt-in alternative desktop layout. It keeps the IC + IC
// Options panes as the first column (so the splitter sizing still finds
// them) but gives the IC Log its own tall pane, OOC below it, and folds
// Music / Players / Main into a tab stack -- more reading room for the
// chat log, which is what most RP sessions stare at. Selectable from
// Settings; Classic remains the default. Switching is content-safe
// because the component factory moves the same live nodes.
window.modernConfig = {
  settings: {
    showPopoutIcon: false,
    showCloseIcon: false,
  },
  dimensions: {
    minItemHeight: 40,
  },
  content: [
    {
      type: "row",
      content: [
        {
          type: "column",
          width: 42,
          content: [
            {
              // Each pane lives in its own stack so golden-layout gives it
              // a draggable tab. Bare components (used in Classic) have no
              // tab to grab, which is why the viewport / IC Options / OOC
              // felt immovable and could get stuck after a drag.
              type: "stack",
              height: 78,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  componentName: "template",
                  title: "IC",
                  componentState: { id: "client_wrapper" },
                },
              ],
            },
            {
              type: "stack",
              height: 22,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  title: "IC Options",
                  componentName: "template",
                  componentState: { id: "icoptions" },
                },
              ],
            },
          ],
        },
        {
          type: "column",
          content: [
            {
              type: "stack",
              height: 50,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  title: "Log",
                  componentName: "template",
                  componentState: { id: "log" },
                },
              ],
            },
            {
              type: "stack",
              height: 28,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  title: "OOC",
                  componentName: "template",
                  componentState: { id: "ooc" },
                },
              ],
            },
            {
              type: "stack",
              height: 22,
              content: [
                {
                  type: "component",
                  isClosable: false,
                  title: "Music",
                  componentName: "template",
                  componentState: { id: "music" },
                },
                {
                  type: "component",
                  isClosable: false,
                  title: "Players",
                  componentName: "template",
                  componentState: { id: "players" },
                },
                {
                  type: "component",
                  isClosable: false,
                  title: "Main",
                  componentName: "template",
                  componentState: { id: "mainmenu" },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

// webCOA: detect mobile/tablet by viewport width and pointer type rather
// than portrait-only (which misclassified landscape phones and portrait
// tablets). A coarse pointer (touch) on a smallish screen, or any narrow
// viewport, gets the stacked single-column layout.
const isMobileDevice =
  window.innerWidth <= 820 ||
  (window.matchMedia &&
    window.matchMedia("(pointer: coarse)").matches &&
    window.innerWidth <= 1024);

let golden = null;
const componentNodeCache = {};

let usingModernLayout = false;
let layoutMode = "modern";
try {
  layoutMode = localStorage.getItem("webcoa_layout") || "modern";
} catch (e) { /* private mode */ }

if (layoutMode === "modern") {
  // Modern: custom CSS-Grid engine (desktop AND mobile). golden-layout is
  // never instantiated, so none of its docking quirks apply. The grid CSS
  // adapts to portrait (stacked) and landscape (viewport-focused) on mobile.
  document.body.classList.add("layout-modern");
  usingModernLayout = true;
  buildModernLayout();
} else {
  golden = new GoldenLayout();
  // Persistent component contents: clone each template's nodes ONCE then
  // MOVE them between containers, so reset/rearrange never wipes the
  // runtime-populated music list, areas, players, OOC log, etc.
  golden.registerComponentFactoryFunction(
    "template",
    (container, componentState) => {
      const id = componentState.id;
      if (!componentNodeCache[id]) {
        const template = document.querySelector(`#${id}`);
        const holder = document.createElement("div");
        holder.innerHTML = template ? template.innerHTML : "";
        componentNodeCache[id] = Array.from(holder.childNodes);
      }
      for (const node of componentNodeCache[id]) {
        container.element.appendChild(node);
      }
    },
  );
  golden.loadLayout(isMobileDevice ? configMobile : config);
}

function adjustSplitter() {
  if (isMobileDevice) return; // Skip for mobile layout
  // Modern layout frames the viewport via CSS (themed pane backdrop) and
  // wraps panes in stacks, so the Classic pixel-height splitter doesn't
  // apply and would mis-measure the stack wrappers. Leave it alone.
  if (document.body && document.body.classList.contains("layout-modern")) return;
  if (!golden) return;
  try {
    const column = golden.root.contentItems[0].contentItems[0];
    const icItem = column.contentItems[0];
    const icOptionsItem = column.contentItems[1];
    if (!icItem || !icOptionsItem) return;
    // Guard: only apply the IC/IC-Options height split when these panes
    // really are the viewport + options stacked together. After the user
    // drags panes around, the fixed indices above can point at unrelated
    // panes; sizing them then produced the gap and collapsed IC Options.
    // Bail in that case and let golden-layout size naturally.
    if (!icItem.element.querySelector("#client_gamewindow")) return;
    if (!icOptionsItem.element.querySelector("#check_nonint")) return;

    const paneWidth = icItem.element.clientWidth;
    // Track the ACTUAL viewport aspect ratio from the selector.
    const aspectSel = document.getElementById('client_viewport_aspect');
    const ratio = aspectSel ? aspectSel.value : '4:3';
    const aspectRatio = ratio === '16:9' ? 0.5625 : ratio === '5:3' ? 0.6 : 0.75;
    const gamewindowHeight = aspectRatio * paneWidth;
    const inputEl = document.getElementById('client_inputbox');
    const barsEl = document.getElementById('client_bars');
    const inputHeight = inputEl ? inputEl.offsetHeight : 30; // fallback
    const barsHeight = barsEl ? barsEl.offsetHeight : 20; // fallback
    const totalHeight = Math.ceil(gamewindowHeight + inputHeight + barsHeight + 45);
    const columnHeight = column.element.clientHeight;
    if (columnHeight === 0) return;

    icItem.element.style.height = `${totalHeight}px`;
    icItem.element.children[1].style.height = `100%`;
    icItem.element.children[1].children[0].style.height = `100%`;
    icItem.element.children[1].children[0].children[0].style.height = `100%`;

    icOptionsItem.element.style.height = `calc(100% - ${totalHeight}px)`;
    icOptionsItem.element.children[1].style.height = `100%`;
    icOptionsItem.element.children[1].children[0].style.height = `100%`;
    icOptionsItem.element.children[1].children[0].children[0].style.height = `100%`;
  } catch (e) {
    // Layout was rearranged into a shape this heuristic doesn't handle;
    // leave sizing to golden-layout rather than breaking the panes.
  }
}

window.addEventListener('resize', () => setTimeout(adjustSplitter, 100));
setTimeout(adjustSplitter, 100); // Initial call

// Also adjust on item resize
if (golden && !usingModernLayout && !isMobileDevice) {
  try {
    golden.root.contentItems[0].contentItems[0].contentItems[0].on("resize", () => setTimeout(adjustSplitter, 50));
  } catch (e) { /* layout shape without the expected IC column */ }
}

// webCOA: reset the dockable layout to the default arrangement. Useful
// when a user drags panes into an unusable configuration (e.g. the IC
// Options pane ends up collapsed). Re-runs the splitter sizing after.
window.resetLayout = function resetLayout() {
  // Modern is a fixed custom grid -- nothing to reset. Classic restores
  // the golden-layout arrangement (content preserved by the node cache).
  if (usingModernLayout) return;
  try {
    golden.loadLayout(config);
    setTimeout(adjustSplitter, 120);
  } catch (e) {
    console.error("resetLayout failed", e);
  }
};

// webCOA: switch between Classic (golden-layout) and Modern (custom grid).
// Because the two use different layout ENGINES, switching reloads the page
// so the chosen engine initializes cleanly. The choice is persisted.
window.setLayout = function setLayout(mode) {
  let current = "modern";
  try {
    current = localStorage.getItem("webcoa_layout") || "modern";
    localStorage.setItem("webcoa_layout", mode);
  } catch (e) { /* private mode */ }
  if (mode !== current) {
    window.location.reload();
  }
};

// Sync the Settings dropdown + theme class to the saved layout on load.
window.initLayoutSelect = function initLayoutSelect() {
  let layoutMode = "modern";
  try {
    layoutMode = localStorage.getItem("webcoa_layout") || "modern";
  } catch (e) { /* ignore */ }
  const sel = document.getElementById("client_layoutselect");
  if (sel) sel.value = layoutMode;
  if (document.body) {
    document.body.classList.toggle("layout-modern", layoutMode === "modern");
  }
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => window.initLayoutSelect());
} else {
  window.initLayoutSelect();
}
